import { useAuthToken } from "./useAuthToken.ts";
import {
  subscribeChat,
  subscribeState,
  unsubscribeChat,
} from "../fetch/subscribe.fetch.ts";
import { useEffect, useState } from "react";

export function useSubscribeChat() {
  const [subscribed, setsubscribed] = useState<
    "unsupported" | "missing_permission" | boolean
  >();
  const auth = useAuthToken();

  useEffect(() => {
    updateSubscribeState();
  }, []);

  const updateSubscribeState = async () => {
    setsubscribed(await subscribeState());
  };

  const subscribe = async () => {
    if (auth.status === "ok") {
      await subscribeChat();
      updateSubscribeState();
    }
  };

  const unsubscribe = async () => {
    if (auth.status === "ok") {
      await unsubscribeChat();
      updateSubscribeState();
    }
  };

  return {
    isSubscribed: subscribed,
    subscribeChat: subscribe,
    unsubscribeChat: unsubscribe,
  };
}
